module.exports = __webpack_public_path__ + "media/images/responsive/fairs/cv/header_online-d9b2feffc6d56e73f32924f84d27bd0e.png";